export default {
	created() {
		console.log(this.$cookies.get('preview-token'))
		if(!this.$cookies.get('preview-token')) {
			this.setCookie();
		}
	},
	methods: {
		setCookie:function(){
			console.log(this.$route.query.api_token)
			this.$cookies.config( [ location.origin ]);
			this.$cookies.set('preview-token', this.$route.query.api_token);
			console.log(this.$cookies.isKey('preview-token'))
		}
	}
}